export default class WSClient {
  constructor(route, withAuth=true) {
    this.ws = {};

    // 0 - CONNECTING
    // 1 - OPEN
    // 2 - CLOSING
    // 3 - CLOSED
    this.state = null;
    this.reconnectAttempt = 0;
    this.reconnectTimeout = null;
    this.maxDelay = 60000;
    this.baseDelay = 4000;

    this.url = '';
    this.route = route;
    this.withAuth = withAuth;

    this.handlers = {};
    this.requests = {};
  }

  connect() {
    if( process.env.VUE_APP_WS_URL ){
      this.url = process.env.VUE_APP_WS_URL + this.route;
    } else {
      this.url = window.location.protocol === 'http:' ? 'ws:' : 'wss:';
      this.url += '//';
      this.url += process.env.VUE_APP_WS_HOST || window.location.host;
      this.url += (process.env.VUE_APP_WS_PORT ? (':' + process.env.VUE_APP_WS_PORT) : '');
      this.url += '/' + (process.env.VUE_APP_WS_PATH ? (process.env.VUE_APP_WS_PATH) : '');
      this.url += '/' + this.route;
    }

    this.ws = new WebSocket(this.url);

    this.ws.onopen = () => {
      this.state = this.ws.readyState;

      if( this.withAuth ) {
        const token = localStorage.getItem('jwt');
        this.ws.send(JSON.stringify({
          type: "auth",
          token: token
        }));
      }
    };

    this.ws.onclose = () => {
      this.state = this.ws.readyState;

      const jitter = Math.random() * 300;
      const delay = Math.min(
        this.baseDelay * Math.pow(2, this.reconnectAttempt),
        this.maxDelay
      ) + jitter;
      this.reconnectAttempt++;

      this.reconnectTimeout = setTimeout(() => {
        this.connect();
      }, delay);
    };


    this.ws.onmessage = (event) => {
      const msg = JSON.parse(event.data);

      if (msg.requestId && this.requests[msg.requestId]) {
        this.requests[msg.requestId](msg);
        delete this.requests[msg.requestId];
      }

      if (msg.type && this.handlers[msg.type]) {
        this.handlers[msg.type](msg.data);
      }
    };
  }

  send(message, callback = null) {
    if (callback) {
      message.requestId = Math.random().toString(36).substring(2);
      this.requests[message.requestId] = callback;
    }
    this.ws.send(JSON.stringify(message));
  }

  on(type, callback) {
    this.handlers[type] = callback;
  }
}
